/* eslint-disable */
import {
    createRouter,
    createWebHistory,
    createWebHashHistory,
} from "vue-router";
/**
 * 頁面宣告載入資料
 */
import {
    About,
    InfoList,
    InfoPage,
    BrandRepair,
    BrandInspection,
    CarList,
    CarPage,
    CarForm,
    CarSuccess,
    CarSuccessLogin,
    CarSuccessJoin,
    SoldEstimate,
    SoldSearch,
    SoldSuccess,
    NotFound,
} from "./pageDatas";

/**
 * 設定檔載入
 */
const setIndexMode = process.env.VUE_APP_INDEX_MODE;
// import NotFound from '../views/NotFound.vue';

//預設路由
const routes = [
    {
        path: "/",
        name: "about",
        component: About,
        meta: {
            title: "認證中古車 - 專業與品質保證的二手車｜LUXLIFE 納智捷",
            content: {
                keyword: "原廠認證中古車,  認證中古車, 中古認證車, 二手車認證, 原廠二手車, 二手車保固, LUXLIFE",
                description: "尋找理想中古車，就選LUXLIFE認證中古車！我們提供 100% 透明的交易、專業認證的車輛、全面保固及量身定制的財務方案，確保您以最合理價格購得心儀車輛。LUXLIFE Excellent Selection（L.E.S）認證中古車不僅是購車的智慧選擇，更是您安心的購車夥伴。",
            },
        },
    },
    {
        path: "/info-list",
        name: "info-list",
        component: InfoList,
        meta: {
            title: "LUXGEN 納智捷｜豐富車款、智能充電、認證中古車的多元服務",
            content: {
                description: "探索納智捷的 U6、URX 等多款車型，並體驗 n7 智能電動車的便利充電生態圈與先進的駕駛科技。並享受我們專業的中古車認證與全面的車輛服務，確保您的每一次駕駛都是一次無憂的體驗。",
            },
        },
    },
    {
        path: "/info-page/:id",
        name: "info-page",
        component: InfoPage,
        meta: {
            title: "LUXGEN 納智捷｜豐富車款、智能充電、認證中古車的多元服務",
            content: {
                description: "探索納智捷的 U6、URX 等多款車型，並體驗 n7 智能電動車的便利充電生態圈與先進的駕駛科技。並享受我們專業的中古車認證與全面的車輛服務，確保您的每一次駕駛都是一次無憂的體驗。",
            },
        },
    },
    {
        path: "/brand-repair",
        name: "brand-repair",
        component: BrandRepair,
        meta: {
            title: "多品牌維修服務 - 汽車保養專家｜LUXLIFE 納智捷認證中古車",
            content: {
                keyword: "汽車保養廠, 汽車維修廠, 汽車保養廠推薦, 汽車修繕",
                description: "無論任何品牌與車型，LUXLIFE 皆提供預約維修保養服務，採用最嚴格的原廠級標準作業流程，並透過嚴謹的技術培訓，為您的愛車提供高品質、且讓人放心的全方位車輛維護。",
            },
        },
    },
    {
        path: "/brand-inspection",
        name: "brand-inspection",
        component: BrandInspection,
        meta: {
            title: "多品牌查定服務 - 中古車鑑定｜LUXLIFE 納智捷認證中古車",
            content: {
                keyword: "認證中古車, 中古認證車, 二手車認證, 原廠二手車, 二手車保固, 車輛查定",
                description: "不限品牌與車型，LUXLIFE皆提供免費專業檢測。讓原廠認證合格的專業技師進行鑑定工作，180項車況查定，確保中古車的品質與透明度，讓您購車更安心、更有保障。",
            },
        },
    },
    {
        path: "/car-list",
        name: "car-list",
        component: CarList,
        meta: {
            title: "車款搜尋 - 多款選擇，實車實價承諾｜LUXLIFE 納智捷認證中古車",
            content: {
                keyword: "中古車交易, u6中古車, urx中古車, luxgen中古車, 納智捷二手車",
                description: "LUXLIFE Excellent Selection（L.E.S）認證中古車，為您提供多款二手車型選擇。我們秉持實車實價的原則，確保您在豐富的車款中，輕鬆挑選到符合預算與需求的理想愛車。從選車開始，到您駕車離開，LUXLIFE專業團隊將全程陪伴，確保您的購車過程安心、順利。",
            },
        },
    },
    {
        path: "/car-page",
        name: "car-page",
        component: CarPage,
        meta: {
            title: "車款搜尋 - 多款選擇，實車實價承諾｜LUXLIFE 納智捷認證中古車",
            content: {
                description: "L.E.S 納智捷認證中古車，為您提供多款二手車型選擇。我們秉持實車實價的原則，確保您在豐富的車款中，輕鬆挑選到符合預算與需求的理想愛車。從選車開始，到您駕車離開，LUXGEN 專業團隊將全程陪伴，確保您的購車過程安心、順利。",
            },
        },
    },
    {
        path: "/car-form/:id",
        name: "car-form",
        component: CarForm,
        meta: {
            title: "車款搜尋 - 多款選擇，實車實價承諾｜LUXLIFE 納智捷認證中古車",
            content: {
                description: "L.E.S 納智捷認證中古車，為您提供多款二手車型選擇。我們秉持實車實價的原則，確保您在豐富的車款中，輕鬆挑選到符合預算與需求的理想愛車。從選車開始，到您駕車離開，LUXGEN 專業團隊將全程陪伴，確保您的購車過程安心、順利。",
            },
        },
    },
    {
        path: "/car-success",
        name: "car-success",
        component: CarSuccess,
        meta: {
            title: "LUXGEN 納智捷｜豐富車款、智能充電、認證中古車的多元服務",
            content: {
                description: "探索納智捷的 U6、URX 等多款車型，並體驗 n7 智能電動車的便利充電生態圈與先進的駕駛科技。並享受我們專業的中古車認證與全面的車輛服務，確保您的每一次駕駛都是一次無憂的體驗。",
            },
        },
    },
    {
        path: "/car-success-login",
        name: "car-success-login",
        component: CarSuccessLogin,
        meta: {
            title: "LUXGEN 納智捷｜豐富車款、智能充電、認證中古車的多元服務",
            content: {
                description: "探索納智捷的 U6、URX 等多款車型，並體驗 n7 智能電動車的便利充電生態圈與先進的駕駛科技。並享受我們專業的中古車認證與全面的車輛服務，確保您的每一次駕駛都是一次無憂的體驗。",
            },
        },
    },
    {
        path: "/car-success-join",
        name: "car-success-join",
        component: CarSuccessJoin,
        meta: {
            title: "LUXGEN 納智捷｜豐富車款、智能充電、認證中古車的多元服務",
            content: {
                description: "探索納智捷的 U6、URX 等多款車型，並體驗 n7 智能電動車的便利充電生態圈與先進的駕駛科技。並享受我們專業的中古車認證與全面的車輛服務，確保您的每一次駕駛都是一次無憂的體驗。",
            },
        },
    },
    {
        path: "/sold-estimate/:orderNum?",
        name: "sold-estimate",
        component: SoldEstimate,
        meta: {
            title: "愛車出售 - 專業鑑價，實現愛車價值｜LUXLIFE 納智捷認證中古車",
            content: {
                keyword: "中古車, 二手車, 原廠認證中古車, 認證中古車, 中古車出售, 二手車估價, 舊車估價",
                description: "LUXLIFE Excellent Selection（L.E.S）納智捷認證中古車為您的愛車提供專業鑑價服務，全面評估您愛車的車況，確保在出售的過程中獲得最合理的價格，並真實反映車輛價值，讓您安心、輕鬆地將愛車轉手。",
            },
        },
    },
    // {
    //     path: "/sold-search",
    //     name: "sold-search",
    //     component: SoldSearch,
    //     meta: {
    //         title: "車價即時查詢 - 掌握市場，安心買賣｜LUXLIFE 納智捷認證中古車",
    //         content: {
    //             keyword: "中古車價查詢, 二手車價查詢, 車價行情查詢,  查詢中古車價, 汽車二手價查詢",
    //             description: "LUXLIFE Excellent Selection（L.E.S）認證中古車的車價即時查詢功能，讓您即時掌握中古車市場的最新價格，無論是購車或賣車，我們的專業評估都能為您提供最合適的價格建議，讓您的交易更加精準、安心。",
    //         },
    //     },
    // },
    {
        path: "/sold-success",
        name: "sold-success",
        component: SoldSuccess,
        meta: {
            title: "車價即時查詢 - 掌握市場，安心買賣｜LUXLIFE 納智捷認證中古車",
            content: {
                description: "L.E.S 納智捷認證中古車的車價即時查詢功能，讓您即時掌握中古車市場的最新價格，無論是購車或賣車，我們的專業評估都能為您提供最合適的價格建議，讓您的交易更加精準、安心。",
            },
        },
    },
    {
        path: "/404",
        name: "not-found",
        component: NotFound,
        meta: {
            title: "LUXGEN 納智捷｜豐富車款、智能充電、認證中古車的多元服務",
            content: {
                description: "探索納智捷的 U6、URX 等多款車型，並體驗 n7 智能電動車的便利充電生態圈與先進的駕駛科技。並享受我們專業的中古車認證與全面的車輛服務，確保您的每一次駕駛都是一次無憂的體驗。",
            },
        },
    },
    {
        path: '/:pathMatch(.*)*',
        component: NotFound,
        meta: {
            title: "LUXGEN 納智捷｜豐富車款、智能充電、認證中古車的多元服務",
            content: {
                description: "探索納智捷的 U6、URX 等多款車型，並體驗 n7 智能電動車的便利充電生態圈與先進的駕駛科技。並享受我們專業的中古車認證與全面的車輛服務，確保您的每一次駕駛都是一次無憂的體驗。",
            },
        },
    },
];

//權限載入路由(之後會補上，先暫時不理會)

//路由選項建立處理
const routesOption = {
    // 依env來決定是否要捨棄#號
    history: setIndexMode == 1 ? createWebHistory() : createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                top: 0,
            };
        }
    },
};

//進行路由建立處理
const router = createRouter(routesOption);
router.beforeEach((to, from, next) => {
    document.body.style.overflow = "";
    const head = document.getElementsByTagName("head");
    const meta = document.createElement("meta");
    if (to.meta.content) {
        document.querySelector('meta[name="keywords"]').setAttribute("content", to.meta.content.keywords);
        document.querySelector('meta[name="description"]').setAttribute("content", to.meta.content.description);
        meta.content = to.meta.content;
        head[0].appendChild(meta);
    }

    if (to.meta.title) {
        document.title = `${to.meta.title}`;
    } else {
        document.title = "LUXGEN";
    }
    next();
});

// this function dynamically change the route title of app and Redirect user to login page if not logged in
// router.beforeEach((to, from, next) => {
// 	document.title = `${to.name} - ${process.env.VUE_APP_TITLE}`;
// 	//不判斷TOKEN的路由
// 	const publicRoutes = [
// 		'/auths/auth-register',
// 		'/auths/auth-login',
// 		'/auths/auth-reset',
// 	];
// 	//const isAuthenticated = localStorage.getItem('nioBoardAuthenticated')

// 	const token = sessionStorage.getItem('accessToken');
// 	const tokenTime = sessionStorage.getItem('tokenTime');
// 	const timestamp = Math.floor(Date.now() / 1000);

// 	//如果為不判斷的路由
// 	if (publicRoutes.includes(to.path)) {
// 		next();
// 	} else {
// 		if (token && tokenTime > timestamp) {
// 			next();
// 		} else {
// 			//next()
// 			//導回登入頁
// 			next('/auths/auth-login');
// 		}
// 	}
// });

export default router;
